import { overEvery, isString, pipe, trim, isEmpty } from 'lodash/fp';
export var isEmptyString = overEvery([isString, pipe([trim, isEmpty])]);
export default isEmptyString;